import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmationModal } from '@bonusly/common-bonus';
import { CloseButton, rem, StyleProps, Tooltip, useDisclosure } from '@bonusly/design-system';

export interface ReferenceUnlinkButtonProps extends StyleProps {
	onClickUnlinkReference: VoidFunction;
	sectionTitle: string;
}

export const ReferenceUnlinkButton: FC<ReferenceUnlinkButtonProps> = ({ onClickUnlinkReference, sectionTitle }) => {
	const confirmUnlinkModal = useDisclosure();
	const { t } = useTranslation('one_on_ones');
	return (
		<>
			<Tooltip label={t('meeting.carousel.unlink_modal.action')} openDelay={500} placement="top">
				<CloseButton
					aria-label={t('meeting.carousel.unlink_modal.action')}
					borderRadius="full"
					boxSize={rem(32)}
					color="gray.400"
					ml={1}
					onClick={(event) => {
						event.preventDefault();
						event.stopPropagation();
						confirmUnlinkModal.onOpen();
					}}
					size="sm"
				/>
			</Tooltip>
			<ConfirmationModal
				size="sm"
				blockScrollOnMount={false}
				confirmText={t('meeting.carousel.unlink_modal.action')}
				description={t('meeting.carousel.unlink_modal.description', {
					sectionTitle,
				})}
				header={t('meeting.carousel.unlink_modal.header')}
				onConfirm={() => {
					confirmUnlinkModal.onClose();
					onClickUnlinkReference();
				}}
				{...confirmUnlinkModal}
			/>
		</>
	);
};
